import { ApptTemplate } from '../../types/apptTemplate';

export const timePlannerHasStaffOnlyItems = (
  selectedTemplate?: ApptTemplate,
) => {
  return (
    selectedTemplate?.entries?.some(
      (entry) => entry.staff_only_planned !== 0,
    ) || false
  );
};
